import { style } from "@vanilla-extract/css";

export const containerStyle = style({
  userSelect: "none",
  display: "inline-flex",
  position: "relative",
  alignSelf: "flex-start",
  alignItems: "center",
  gap: "s",
});

export const contentStyle = style({
  filter: "blur(8px)",
});

export const iconStyle = style({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
});
